import { Injectable } from '@angular/core';
import { FactoryService } from '../../factory/services/factory.service';

@Injectable({
  providedIn: 'root'
})
export class QueryResponseDataConverterService {

  constructor(private factoryService: FactoryService) { }

  converter<T>(data: any, type): T {
    const result: T = this.create<T>(type);
    result["Id"] = data.Id;
    if (data.HasDocuments) {
      result["HasDocuments"] = data.HasDocuments;
    }
    if (data.DataFields) {
      for (
        let innerIndex = 0;
        innerIndex < data.DataFields.length;
        innerIndex++
      ) {
        const innerElement = data.DataFields[innerIndex];
        const dataHeader: string = this.headerConverter(innerElement.Header);
        result[dataHeader] = innerElement.Value;
      }
    }

    return result;
  }

  create<T>(type) {
    return this.factoryService.create<T>(type);
  }

   /**
   * Maybe at some point you could cache these and allow for faster load times... not sure how yet
   * @param header The header from the DTO
   */
  headerConverter(header: string): string {
    let value: string;
    if (header.includes(" ")) {
      const spacedParts = header.split(" ");
      value = spacedParts[spacedParts.length - 1];
    } else {
      const dottedParts = header.split(".");
      value = dottedParts[dottedParts.length - 1];
    }
    return value;
  }
}
